// #1107 — Single source of truth for the family-relation vocabulary used
// by the signup relation selector, the intake family editor, and the
// Portal family + account screens.
//
// Before #1107 this list lived as FOUR divergent hardcoded arrays
// (Signup.js inline <option>s, IntakeReview.js RELATIONSHIP_OPTIONS,
// Portal.js RELATIONSHIP_OPTIONS + the account-settings RELATIONS) that
// had already drifted out of sync — adding an option to one and not the
// others was a recurring rule-9 "half-change". One array here, imported
// everywhere, with per-language labels in translations.js (`relations`
// namespace) keyed by these exact values.
//
// Order: English-alphabetical (matching the #265 decision for the signup
// selector), with the "family member" catch-all pinned last.

export const RELATION_VALUES = [
  'aunt',
  'boyfriend',
  'brother',
  'caregiver',
  'daughter',
  'ex',
  'father',
  'girlfriend',
  'grandchild',
  'mother',
  'nephew',
  'niece',
  'parent',
  'partner',
  'sibling',
  'sister',
  'son',
  'spouse',
  'uncle',
  'family member',
];

// Default relation for a freshly-added family member / unset selector —
// the catch-all, so a half-filled row still round-trips meaningfully.
export const DEFAULT_RELATION = 'family member';

function titleCase(v) {
  return String(v).replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

/**
 * Translate a single stored relation value for display. Falls back to a
 * title-cased value if a label is somehow missing — the relations parity
 * test keeps every value translated in every language, so the fallback
 * is defence, not the happy path.
 */
export function relationLabel(t, value) {
  if (!value) return '';
  const labels = (t && t.relations) || {};
  return labels[value] || titleCase(value);
}

/**
 * Build the {value, label} option list for a relation <select>, labels
 * translated into the active language. `t` is the translations object
 * from useLang().
 */
export function relationOptions(t) {
  return RELATION_VALUES.map((value) => ({ value, label: relationLabel(t, value) }));
}
